const synergies = [
  {
    name: "Aristotle University of Thessaloniki",
    url: "https://auth.gr/",
    image: "/images/synergies/apth-logo.png",
    description:
      "Aristotle University of Thessaloniki is one of Greece’s largest and most prominent universities, with a broad academic and research presence across disciplines. Through its educational, scientific and innovation activities, AUTh contributes valuable academic expertise, research capacity and institutional knowledge to collaborative European projects."
  },
  {
    name: "Benaki Phytopathological Institute",
    url: "https://en.bpi.gr/",
    image: "/images/synergies/benakion-logo.png",
    description:
      "Benaki Phytopathological Institute is a leading Greek research institute specialising in plant health, plant protection, pesticide residues, phytosanitary control and sustainable agriculture. Its scientific work supports safer food systems, agricultural resilience and evidence-based responses to plant pests and diseases."
  },
  {
    name: "HELMEPA",
    url: "https://www.helmepa.gr/",
    image: "/images/synergies/Helmepa_logo.jpg",
    description:
      "HELMEPA promotes marine environmental protection, safety at sea and sustainability awareness across the maritime community. Through training, environmental education, youth engagement and industry initiatives, the organisation supports responsible shipping practices and the protection of seas and coastal ecosystems."
  },
  {
    name: "HEMEXPO",
    url: "https://hemexpo.gr/",
    image: "/images/synergies/hemexpo-logo.jpg",
    description:
      "HEMEXPO represents Greek marine equipment manufacturers and exporters, promoting the country’s maritime technology and industrial expertise internationally. The association supports innovation, export activity and collaboration within the shipping sector, connecting Greek maritime suppliers with global markets and industry stakeholders."
  },
  {
    name: "I-BEC",
    url: "https://i-bec.org/el/",
    image: "/images/synergies/ibec-logo.png",
    description:
      "I-BEC, the Interbalkan Environment Center, works through national and international networks to support environmental management, sustainable development and the use of integrated information systems. Its activities connect research, public authorities, businesses and institutions in areas such as natural resources, environmental data and regional development."
  },
  {
    name: "Militos Consulting S.A.",
    url: "https://militos.org/en/",
    image: "/images/synergies/militos-logo.png",
    description:
      "Militos Consulting S.A. provides business consultancy, project management, communication, training and innovation-support services, with strong experience in European projects. The company helps organisations transform ideas into structured initiatives, develop strategies, manage complex partnerships and create sustainable project outcomes."
  },
  {
    name: "MSCOMM",
    url: "https://mscommgroup.com/",
    image: "/images/synergies/mscom-logo.png",
    description:
      "MSCOMM is an Athens-based communications agency offering strategic communication, public relations, digital services, content development and event management. The company supports public and private sector clients with integrated campaigns, media relations, stakeholder engagement and creative communication actions."
  },
  {
    name: "Position Green",
    url: "https://www.positiongreen.com/",
    image: "/images/synergies/position-green-logo.jpg",
    description:
      "Position Green provides ESG software and advisory services that help organisations collect sustainability data, automate reporting, track emissions and align with evolving regulatory frameworks. Its platform and expert support enable companies to turn sustainability performance into clearer reporting, stronger compliance and long-term business value."
  },
  {
    name: "RWO",
    url: "https://www.rwo.de/",
    image: "/images/synergies/rwo-logo.jpg",
    description:
      "RWO develops marine water treatment technologies for ships and offshore installations, including systems for bilge water, ballast water, sewage, freshwater and process water treatment. With long-standing technical expertise and a global service network, RWO supports cleaner vessel operations and compliance with environmental standards."
  },
  {
    name: "Sea Teach",
    url: "https://sea-teach.org/",
    image: "/images/synergies/seateach-logo.jpg",
    description:
      "Sea Teach designs, manages and coordinates European maritime projects that connect education, research and innovation. Its work focuses on ocean education, maritime employment, sustainability and skills development, creating practical learning pathways and long-term impact across the blue economy."
  },
  {
    name: "Tyre Foundation",
    url: "https://www.fondationtyr.org/en/home",
    image: "/images/synergies/tyre-foundation-logo.png",
    description:
      "Tyre Foundation supports the preservation, promotion and sustainable development of Tyre, one of the world’s oldest cities and an important historical and archaeological site. Through cultural, educational and international awareness activities, the foundation works to protect heritage and connect the city’s past with future development."
  },
  {
    name: "University of Thessaly",
    url: "https://www.uth.gr/en",
    image: "/images/synergies/uth-logo.png",
    description:
      "The University of Thessaly is a public higher education institution with a strong academic, research and innovation profile across multiple cities in central Greece. Through its departments, laboratories, Erasmus+ activity and research initiatives, UTH contributes scientific knowledge, technical expertise and educational capacity to collaborative projects."
  }
];

export default synergies;